/**
 * Iso city — cool monochrome ink; color reserved for health beacons only.
 */

export const BP = {
	bg: "transparent",
	gridMajor: "rgba(15, 18, 26, 0.055)",
	gridMinor: "rgba(15, 18, 26, 0.028)",
	road: "rgba(15, 18, 26, 0.072)",
	label: "rgba(22, 24, 32, 0.46)",
	muted: "rgba(22, 24, 32, 0.32)",
	/** Selection ring — not a brand hue */
	accent: "#252a38",
	ink: "#13151c",
} as const;

/** Health beacons only — cool, distinct tiers */
export const HEALTH_STROKE: Record<string, string> = {
	thriving: "#2dd4bf",
	healthy: "#38bdf8",
	stale: "#64748b",
	neglected: "#818cf8",
	critical: "#f43f5e",
};
